import React from 'react';
import AboutHeader from "./AboutHeader";
import Footer from './landing/Footer';
import Header from './landing/Header';
const AboutUs = () => {
    const coreValues = [
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-12 h-12 text-blue-600 mx-auto mb-2" aria-hidden="true">
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="12" r="6"></circle>
                    <circle cx="12" cy="12" r="2"></circle>
                </svg>
            ),
            label: "Mission",

        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock w-12 h-12 text-green-600 mx-auto mb-2" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
            ),
            label: "Fast Service",

        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-award w-12 h-12 text-purple-600 mx-auto mb-2" aria-hidden="true"><path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path><circle cx="12" cy="8" r="6"></circle></svg>
            ),
            label: "Quality",

        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-heart w-12 h-12 text-red-600 mx-auto mb-2" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path></svg>
            ),
            label: "Care",

        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users w-12 h-12 text-orange-600 mx-auto mb-2" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><path d="M16 3.128a4 4 0 0 1 0 7.744"></path><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><circle cx="9" cy="7" r="4"></circle></svg>
            ),
            label: "Expert Team",

        }
    ];

    return (
        <div className="min-h-screen bg-white">
            <Header />
            {/* Blue Header */}
            <div className="bg-blue-600 py-16">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                        About Us
                    </h1>
                </div>
            </div>

            {/* Core Values Section */}
            <div className="container mx-auto px-4 py-12">
                <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 mb-16">
                    {coreValues.map((value, index) => (
                        <div key={index} className="flex flex-col items-center text-center">
                            <div className="mb-3">
                                {typeof value.icon === 'string' ? (
                                    <div className="text-4xl md:text-5xl">{value.icon}</div>
                                ) : (
                                    value.icon
                                )}
                            </div>
                            <span className='text-sm text-gray-600'>
                                {value.label}
                            </span>
                        </div>
                    ))}
                </div>

                {/* Content Section */}
                <div className="max-w-4xl mx-auto space-y-6">
                    <div className="max-w-4xl mx-auto px-4 py-12">
                        <div class="flex items-start">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-brain w-6 h-6 text-blue-600 mr-4 mt-1 flex-shrink-0" aria-hidden="true"><path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path><path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"></path><path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"></path><path d="M17.599 6.5a3 3 0 0 0 .399-1.375"></path><path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"></path><path d="M3.477 10.896a4 4 0 0 1 .585-.396"></path><path d="M19.938 10.5a4 4 0 0 1 .585.396"></path><path d="M6 18a4 4 0 0 1-1.967-.516"></path><path d="M19.967 17.484A4 4 0 0 1 18 18"></path></svg>
                            <div class="text-lg text-gray-700 leading-relaxed">
                                <p class="mb-6">ADHDRapidCare was created to solve the long-standing failures in ADHD
                                    diagnosis and care -long wait times, high costs, and inadequate follow-up
                                    support. These issues have left thousands of Australians without access to the
                                    help they need.</p>
                                <p class="mb-6">Our solution is both powerful and truly groundbreaking.</p>
                                <p class="mb-6">We are the first service in the world to offer weekly AI-enhanced ADHD
                                    monitoring via SMS, giving patients real-time support between appointments.
                                    Combined with monthly specialist nurse consultations and rapid access to
                                    escalation when needed, our Care Plan offers a level of ongoing support that is
                                    genuinely unparalleled.</p>
                                <p class="mb-6">We work only with qualified, highly trained ADHD clinicians and nurses,
                                    supported by cutting-edge AI systems that ensure faster turnaround, better
                                    insights, and consistent care. Our platform was developed in consultation with
                                    world renowned medical experts in ADHD and digital health innovation.</p>
                                <p>The result is an affordable, world-class service that provides continuous ADHD
                                    care - something no traditional clinic currently offers.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default AboutUs;
